import gql from "graphql-tag";
import { configContent } from '~/graphql/queries/configContent'

export const configQuery = gql`
  query Config {
    ${configContent}
  }
`